// extracted by mini-css-extract-plugin
export default {"heading":"BiddingStrategy_heading__91NcE","wrapper":"BiddingStrategy_wrapper__71fid","bidStrategyContainer":"BiddingStrategy_bidStrategyContainer__qZj9s"};